// Iter 50 — Hinglish/English string lookup.
// Lightweight key→{en, hi} map (no i18n library). Each component reads via
// the `t(key)` helper from LanguageContext.
//
// IMPORTANT: financial / technical terms traders already use in English
// (Net P&L, Win Rate, Profit Factor, Expectancy, Risk:Reward, Stop Loss,
// Health Score, Journaling Streak) are intentionally NOT in this table —
// they stay in English regardless of the active language.
export const STRINGS = {
  "dashboard.subtitle": {
    en: "Your trading edge — at a glance.",
    hi: "Tumhara trading edge — ek nazar mein.",
  },
  "health.message.elite": {
    en: "You trade like a pro",
    hi: "Tum pro jaisa trade karte ho",
  },
  "nba.overtrading.title": {
    en: "Slow down",
    hi: "Thoda slow karo",
  },
  "nba.overtrading.message_one": {
    en: "You overtraded on 1 day — aim for fewer, better setups.",
    hi: "1 din zyada trade kiya — kam, behtar setups pe focus karo.",
  },
  "nav.add_trade": {
    en: "+ Log Trade",
    hi: "Trade Log Karo",
  },
};

// Returns the value for the active language; falls back to English if a
// key isn't translated yet (we want partial translations to ship safely).
export function lookup(key, lang) {
  const entry = STRINGS[key];
  if (!entry) return key; // missing key → echo so it's obvious in dev
  return entry[lang] || entry.en || key;
}

// ── Value-based lookup ──
// Some strings arrive from the backend (e.g. Health Score `message` or the
// Next Best Action `title` / `message`). Build a reverse map keyed by the
// English text so callers can translate without knowing the key. Any
// unknown text passes through unchanged — partial translation is safe.
const BY_EN_TEXT = Object.fromEntries(
  Object.entries(STRINGS).map(([, v]) => [v.en, v])
);
export function translateText(text, lang) {
  if (!text || typeof text !== "string") return text;
  const entry = BY_EN_TEXT[text];
  if (!entry) return text;
  return entry[lang] || entry.en || text;
}
